import {
    Box, Button, Chip, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer,
    TableHead, TablePagination, TableRow, TextField, Tooltip, Typography
} from "@mui/material";
import { Component } from "react";
import { GridTable } from "../../Sidebar/SidebarStyles";
import { getAutoDispatcherJobsList, getAutoDispatchJobReport, RetryAutoDispatcherFailedJobs, updateDispatchStatusByJobId } from "../../ApiSevices/JobListingApis";
import { Check, Clear, Refresh, Replay, Search } from "@mui/icons-material";


interface IProps {
    displaysidebar: boolean;
    allowedMenus: any[];
}

interface DispatchDModal {
    openDialog: boolean;
    selectedJob: string;
    dispatchFlag: boolean;
    message: string;
}

interface IState {
    loading: boolean;
    statusId: any;
    page: number;
    rowsPerPage: number;
    searchText: string;
    AutoDispatchJobProcessData: any;
    snackbarOpen: boolean;
    snackbarMessage: string;
    snackbarSeverity: 'success' | 'error' | 'info' | 'warning';
    modalData: DispatchDModal;
    selectedRow: any;
    isReProcessDialogOpen: boolean;
    isReprocess: boolean;
}

const StatusMaster = [
    { "Id": 1, "Name": "Pending" },
    { "Id": 2, "Name": "InProgress" },
    { "Id": 3, "Name": "Completed" },
    { "Id": 4, "Name": "Failed" }
]

const headCells: any[] = [
    { id: 'JobId', label: 'JobId', disableSort: true },
    { id: 'StatusId', label: 'Status', disableSort: true },
    { id: 'StpMatched', label: 'StpMatched', disableSort: true },
    { id: 'IsActive', label: 'IsActive', disableSort: true },
    { id: 'Dispatch', label: 'Dispatch Enabled', disableSort: true },
    { id: 'CreatedOn', label: 'CreatedOn', disableSort: true },
    { id: 'Message', label: 'Message', disableSort: true },
    { id: 'Action', label: 'Action', disableSort: true }
];

const columnWidths = {
    JobId: 160,
    StatusId: 100,
    IsActive: 100,
    Dispatch: 120,
    CreatedOn: 120,
    Message: 190,
    StpMatched: 100,
    Action: 70,
};

export default class AutoDispatcher extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            statusId: 0,
            page: 0,
            rowsPerPage: 100,
            searchText: "",
            AutoDispatchJobProcessData: {},
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'success',
            modalData: { openDialog: false, selectedJob: "", dispatchFlag: false, message: "" },
            selectedRow: {},
            isReProcessDialogOpen: false,
            isReprocess: false
        }
    }

    async componentDidMount(): Promise<void> {
        await this.getData();
    }

    getData = async (): Promise<void> => {
        try {
            this.setState({ loading: true });
            const { page, rowsPerPage, statusId, searchText } = this.state;
            const response = await getAutoDispatcherJobsList(page, rowsPerPage, statusId, searchText);
            this.setState({ AutoDispatchJobProcessData: response });
        } catch (error) {
            this.setState({ AutoDispatchJobProcessData: [] });
            console.error(error);
        } finally {
            this.setState({ loading: false });
        }
    }

    handleSearchClick = async (): Promise<void> => {
        this.setState({ page: 0, rowsPerPage: 100 }, this.getData);
    }

    handleChangePage = (_: unknown, newPage: number) => {
        this.setState({ page: newPage }, () => {
            this.getData();
        });
    };

    handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        this.setState({ rowsPerPage: newRowsPerPage, page: 0 }, () => {
            this.getData();
        });
    };

    // getColumnWidth = (column: string) => {
    //     if (["JobId", "CreatedOn"]?.includes(column)) {
    //         return 120;
    //     }
    //     else if (["StatusId", "IsActive", "Dispatch", "Action"]?.includes(column)) {
    //         return 90;
    //     }
    //     else if (["Message"]?.includes(column)) {
    //         return 200;
    //     }
    //     else {
    //         return 150;
    //     }
    // }

    handleOpenDialog = (selectedJob: string = "", dispatchFlag: boolean = false, message: string = "", isReprocess: boolean = false) => {
        this.setState({ modalData: { openDialog: true, selectedJob, dispatchFlag, message }, isReprocess: isReprocess });
    }

    handleCloseDialog = () => {
        this.setState({ modalData: { openDialog: false, selectedJob: "", dispatchFlag: false, message: "" }, isReprocess: false });
    }

    refresh = () => {
        this.setState({ searchText: '', statusId: 0, page: 0, }, () => { this.getData(); });
    }

    updateDispatchStatus = async (): Promise<void> => {
        try {
            this.setState({ loading: true });
            const { modalData, isReprocess } = this.state;
            if (isReprocess) {
                this.reprocess();
                return;
            }
            await updateDispatchStatusByJobId(modalData.selectedJob, modalData.dispatchFlag);
            this.handleCloseDialog();
            this.refresh();
        } catch (error) {
            console.error(error);
        } finally {
            this.setState({ loading: false });
        }
    }

    reprocess = async () => {
        try {
            const { modalData } = this.state;
            await RetryAutoDispatcherFailedJobs(modalData.selectedJob);
            this.handleCloseDialog();
            this.refresh();
        } catch (error) {
            console.error(error);
        } finally {
            this.setState({ loading: false });
        }
    }

    handleExport = async () => {
        this.setState({ loading: true });
        try {
            const fileBlob = await getAutoDispatchJobReport();
            const url = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = url;

            const now = new Date();
            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();

            const formattedDate = `${day}${month}${year}`;
            const filename = `AutoDispatchJobs${formattedDate}.xlsx`;
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting production report:', error);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { loading, AutoDispatchJobProcessData, page, rowsPerPage, modalData } = this.state;
        const total_count = AutoDispatchJobProcessData?.totalCount || 0;
        return (
            <div style={{ fontSize: "12px" }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable displaysidebar={this?.props?.displaysidebar}>
                    {/* <p><b>Auto Dispatcher</b></p><br /> */}
                    <Box display="flex" gap={2} alignItems="center">
                        <Box>
                            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                                Select Status
                            </Typography>
                            <Select
                                size="small"
                                value={this.state.statusId}
                                onChange={(event) => {
                                    const selectedStatusId = event.target.value;
                                    this.setState({ statusId: selectedStatusId, page: 0 }, this.getData);
                                }}
                                displayEmpty
                                sx={{ minWidth: 120, fontSize: '12px' }}
                            >
                                <MenuItem value="0" sx={{ fontSize: '12px' }}>All</MenuItem>
                                {StatusMaster?.map((status) => (
                                    <MenuItem key={status.Id} value={status.Id.toString()} sx={{ fontSize: '12px' }}>
                                        {status.Name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>
                        <Box display="flex" alignItems="center" gap={0} sx={{ mt: 3 }}>
                            {/* Search */}
                            <TextField
                                size="small"
                                placeholder="Search by Job ID"
                                value={this.state.searchText}
                                onChange={(e) => { this.setState({ searchText: e?.target?.value || "" }) }}
                                sx={{
                                    '& .MuiInputBase-input::placeholder': { fontSize: '11px' },
                                    '& .MuiInputBase-input': { fontSize: '11px' },
                                    width: 180,
                                }}
                            />
                            <Tooltip title="Click here for search result">
                                <IconButton
                                    onClick={this.handleSearchClick}
                                    sx={{ mr: 1.5, height: '33px', border: '0.2px solid #d0bcbca1', borderRadius: '9%' }}
                                >
                                    <Search fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Box sx={{ marginTop: '26px' }}>
                            <Tooltip title="Click here to refresh the table">
                                <span>
                                    <Refresh
                                        sx={{
                                            cursor: 'pointer',
                                            color: 'blue',
                                            border: '0.1px solid black',
                                            borderRadius: '4px',
                                            padding: '3px',
                                            height: 30,
                                            width: 30,
                                            mr: 1.5,
                                            mt: 0.1,
                                            boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 8px',
                                        }}
                                        onClick={() => { this.refresh() }}
                                    />
                                </span>
                            </Tooltip>
                        </Box>
                        <Box sx={{ marginTop: '26px' }}>
                            <Tooltip title="Click here to Export as excel">
                                <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                        backgroundColor: '#5bc0de',
                                        fontSize: '0.75rem',
                                        height: 30,
                                        textTransform: 'none',
                                        fontWeight: 'bold',
                                    }}
                                    onClick={() => this.handleExport()}
                                >
                                    Export as Excel
                                </Button>
                            </Tooltip>
                        </Box>
                    </Box>
                    <br />
                    <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
                        <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
                            <TableContainer sx={{ minWidth: 'max-content' }}>
                                <Table stickyHeader sx={{ height: '40px' }} size="small">

                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: 60, fontSize: '10px', fontWeight: 'bold' }}>
                                                S.No
                                            </TableCell>

                                            {headCells?.map((headCell) => (
                                                <TableCell
                                                    key={headCell.id}
                                                    sx={{
                                                        width: columnWidths[headCell.id as keyof typeof columnWidths] || 190, // fallback width
                                                        minWidth: columnWidths[headCell.id as keyof typeof columnWidths] || 190,
                                                        fontSize: '10px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'center',
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word'
                                                    }}
                                                >
                                                    {headCell.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>

                                {/* ===== TABLE BODY ===== */}
                                <Box sx={{ maxHeight: 310, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                    <Table size="small">
                                        <TableBody>
                                            {AutoDispatchJobProcessData?.data?.length === 0 ? (
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={headCells.length + 1}
                                                        align="center"
                                                        sx={{
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                            color: 'gray',
                                                            py: 3
                                                        }}
                                                    >
                                                        No records to display
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                AutoDispatchJobProcessData?.data?.map((row: any, index: number) => (
                                                    <TableRow hover key={row.Id}>

                                                        <TableCell sx={{ width: 60, fontSize: '10px' }}>
                                                            {page * rowsPerPage + index + 1}
                                                        </TableCell>

                                                        <TableCell
                                                            sx={{
                                                                width: columnWidths["JobId"],
                                                                fontSize: '10px',
                                                                textAlign: 'center',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            {row.JobId}
                                                        </TableCell>

                                                        <TableCell sx={{ width: columnWidths["StatusId"], textAlign: 'center' }}>
                                                            <Chip
                                                                label={
                                                                    StatusMaster?.find(f => f?.Id === row?.StatusId)?.Name || ""
                                                                }
                                                                size="small"
                                                                sx={{
                                                                    fontWeight: 500,
                                                                    fontSize: '11px',
                                                                    height: '22px',
                                                                    borderRadius: '20px'
                                                                }}
                                                            />
                                                        </TableCell>

                                                        <TableCell
                                                            sx={{
                                                                width: columnWidths["StpMatched"],
                                                                fontSize: '10px',
                                                                textAlign: 'center',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            <Chip
                                                                label={row?.StpMatched ? "Green" : "Red"}
                                                                size="small"
                                                                color={row?.StpMatched ? "success" : "error"}
                                                                sx={{
                                                                    fontWeight: 500,
                                                                    fontSize: '11px',
                                                                    height: '22px',
                                                                    borderRadius: '20px'
                                                                }}
                                                            />
                                                        </TableCell>
                                                        
                                                        <TableCell
                                                            sx={{
                                                                width: columnWidths["IsActive"],
                                                                fontSize: '10px',
                                                                textAlign: 'center',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            {row?.IsActive ? "True" : "False"}
                                                        </TableCell>

                                                        <TableCell
                                                            sx={{
                                                                width: columnWidths["Dispatch"],
                                                                fontSize: '10px',
                                                                textAlign: 'center',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            {row?.Dispatch ? "True" : "False"}
                                                        </TableCell>

                                                        <TableCell
                                                            sx={{
                                                                width: columnWidths["CreatedOn"],
                                                                fontSize: '10px',
                                                                textAlign: 'center',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            {row?.CreatedOn}
                                                        </TableCell>

                                                        <TableCell
                                                            sx={{
                                                                width: columnWidths["Message"],
                                                                fontSize: '10px',
                                                                textAlign: 'center',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            {row?.Message}
                                                        </TableCell>


                                                        <TableCell
                                                            sx={{
                                                                width: columnWidths["Action"],
                                                                fontSize: '10px',
                                                                textAlign: 'center',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                                <Tooltip title={`Click here to ${row.Dispatch ? "disable" : "enable"}`}>
                                                                    {
                                                                        row?.Dispatch ?
                                                                            <Clear color="error" fontSize="small" onClick={() => { this.handleOpenDialog(row?.JobId, false, "Are you sure you want to disable the auto dispatcher for job: " + row?.JobId) }} /> :
                                                                            <Check color="success" fontSize="small" onClick={() => { this.handleOpenDialog(row?.JobId, true, "Are you sure you want to enable the auto dispatcher for job: " + row?.JobId) }} />
                                                                    }
                                                                </Tooltip>

                                                                {row.StatusId === StatusMaster.find(status => status.Name === 'Failed')?.Id && (
                                                                    <Tooltip title="ReProcess">
                                                                        <IconButton onClick={() => { this.handleOpenDialog(row?.JobId, true, "Are you sure you want to ReProcess the auto dispatcher job: " + row?.JobId, true) }} size="small">
                                                                            <Replay fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                        </TableCell>

                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </TableContainer>
                        </Box>

                        <TablePagination
                            rowsPerPageOptions={[5, 10, 20, 50, 100]}
                            component="div"
                            count={total_count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                    </Paper>
                    <Dialog open={modalData?.openDialog} onClose={() => { this.handleCloseDialog() }}>
                        <DialogContent sx={{
                            padding: '0px 30px',
                            paddingTop: '15px',
                            paddingBottom: '20px',
                            textAlign: 'center',
                        }}>
                            <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0, minWidth: "200px" }}>
                                Auto Disptach Record
                            </DialogTitle>
                            <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                {modalData?.message}
                            </DialogContentText>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        px: 4,
                                        borderRadius: '6px',
                                    }}
                                    onClick={() => { this.updateDispatchStatus() }}
                                >
                                    Yes
                                </Button>
                                <Button
                                    variant="outlined"
                                    onClick={() => { this.handleCloseDialog() }}
                                    sx={{
                                        color: '#007bff',
                                        borderColor: '#007bff',
                                        border: '0.5px solid #53494987',
                                        px: 4,
                                        borderRadius: '6px',
                                        '&:hover': {
                                            borderColor: '#0056b3',
                                            color: '#0056b3',
                                        },
                                    }}
                                >
                                    No
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>
                </GridTable >
            </div >
        )
    }
}